import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const AgConvergePopup = () => {
  const [visible, setVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0
  });

  useEffect(() => {
    const alreadyDismissed = sessionStorage.getItem('agconvergePopupDismissed');

    if (!alreadyDismissed) {
      const showTimer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(showTimer);
    }
  }, []);

  useEffect(() => {
    const eventDate = new Date('2026-11-17T09:00:00');

    const updateCountdown = () => {
      const now = new Date();
      const diff = eventDate - now;

      if (diff > 0) {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 60000);

    return () => clearInterval(timer);
  }, []);

  const dismissPopup = () => {
    setVisible(false);
    sessionStorage.setItem('agconvergePopupDismissed', 'true');
  };

  if (!visible) return null;

  return (
    <div className="pp1-overlay" onClick={dismissPopup}>
      <div className="pp1" onClick={(e) => e.stopPropagation()}>
        <div className="pp1-top">
          <span className="ticker-text">New conference announced</span>
          <button onClick={dismissPopup} aria-label="Close">&times;</button>
        </div>
        <div className="pp1-body">
          <div className="pp1-icon"><i className="fas fa-bullhorn"></i></div>
          <h3>Spur AgConverge 2026 is coming</h3>
          <div className="pp1-countdown">
            <div className="pp1-cu"><span className="n">{timeLeft.days}</span><span className="l">Days</span></div>
            <div className="pp1-cu"><span className="n">{timeLeft.hours}</span><span className="l">Hrs</span></div>
            <div className="pp1-cu"><span className="n">{timeLeft.minutes}</span><span className="l">Min</span></div>
          </div>
          <div className="pp1-details">
            <div className="pp1-drow"><i className="far fa-calendar"></i> November 17 &amp; 18, 2026</div>
            <div className="pp1-drow"><i className="fas fa-map-marker-alt"></i> Raising Nebraska, Grand Island NE</div>
          </div>
          <Link
            to="/agconverge"
            className="pp1-btn"
            onClick={dismissPopup}
          >
            Register Now
          </Link>
          <span className="pp1-skip" onClick={dismissPopup}>Not now &mdash; remind me later</span>
        </div>
      </div>
    </div>
  );
};

export default AgConvergePopup;
